// extracted by mini-css-extract-plugin
export default {"container":"MyApplications_container__e5xlY","filter":"MyApplications_filter__LjeBu","selectedFilters":"MyApplications_selectedFilters__3LAa3"};